import type React from 'react';
import { createContext, useContext } from 'react';
import { useReCaptchaV2, useReCaptchaV3 } from './hooks';

type ReCaptchaContext = {
  v2: ReturnType<typeof useReCaptchaV2>;
  v3: ReturnType<typeof useReCaptchaV3>;
};

const Context = createContext<ReCaptchaContext>({} as ReCaptchaContext);

type Props = React.PropsWithChildren;

export const ReCaptchaProvider = ({ children }: Props) => {
  const v2 = useReCaptchaV2();
  const v3 = useReCaptchaV3();

  const value = { v2, v3 };

  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export const useReCaptcha = () => {
  const context = useContext(Context);

  if (!context) {
    throw new Error('useReCaptcha must be used within a ReCaptchaProvider');
  }

  return context;
};
